module.exports = __webpack_public_path__ + "static/img/manual-54.f76946d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-54.png
// module id = uKV+
// module chunks = 4